import { render } from "./CometChatBackdrop.vue?vue&type=template&id=18ad027a"
import script from "./CometChatBackdrop.vue?vue&type=script&lang=js"
export * from "./CometChatBackdrop.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__